<template>
  <v-row align="center">
    <v-col class="px-2" :class="(moreDetails? 'xs5': 'xs9')" >
      <v-text-field
        prepend-icon="email"
        v-model="email.value"
        :label="$t('locations.email')"
      ></v-text-field>
    </v-col>
    <v-col class="px-2" cols="4" v-if="moreDetails" >
      <v-text-field
        v-model="email.type"
        :label="$t('general.type')"
      ></v-text-field>
    </v-col>
    <v-col cols="1">
      <span style="font-size:12px">{{$t('general.public')}}</span> <br>
      <v-checkbox
        class="mt-0"
        v-model="email.public"
        color="kazan"
      ></v-checkbox>
    </v-col>
    <v-col cols="2" >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="icon-btn" small text icon color="accent" v-on="on" @click="removeEmail(index)">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </template>
        <span>{{$t('buttons.remove')}}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="email.value !== '' && isLast">
        <template v-slot:activator="{ on }">
          <v-btn class="icon-btn" small text icon color="kazan" v-on="on" @click="$emit('addBlankEmail')">
            <v-icon>control_point</v-icon>
          </v-btn>
        </template>
        <span>{{$t('buttons.add')}}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'ContactFormEmail',
  components: {},
  props: {
    moreDetails: Boolean,
    isLast: Boolean,
    index: Number,
    email: Object
  },
  methods: {
    removeEmail (index) {
      this.$emit('removeEmail', index)
    }
  }
}
</script>
